import React from 'react';
import { Tab as BSTab, TransitionCallbacks, Omit} from "react-bootstrap";

export interface TabProps extends TransitionCallbacks, Omit<React.HTMLProps<any>, "title"> {
    animation?: boolean;
    eventKey?: any;
    unmountOnExit?: boolean;
    tabClassName?: string;
    title?: React.ReactNode; // Override HTMLProps.title to allow nodes not just strings
}

export const Tab: React.FC<TabProps> = (props) => {
    return (
        <BSTab {...props}>
            {props.children}
        </BSTab>
    )
}

(Tab as any).displayName = 'Tab';